// extracted by mini-css-extract-plugin
export default {"application":"Application_application__S4iiU","application__video":"Application_application__video__Uhyaj"};